import { types } from 'mobx-state-tree';

const ExternalReview = types.model('ExternalReview', {
  type: types.string,
  reviews_count: types.number,
  reviews_average: types.number
});

export default ExternalReview;



// WEBPACK FOOTER //
// ./src/models/ExternalReview.js